import { string, addMethod } from 'yup';
import { formatTn } from '../../data/formatTn';

/**
 * Adds a method to yup.string that converts a TN (10 digits only) into either the default format or the format provided.
 * The format should contain "npa", "nxx", and "xxxx" arragned as desired.
 * The Yup method that gets created accepts the same optional parameters to override the defaults.
 *
 * @module
 *
 * @param {string} [defaultFormat='npa-nxx-xxxx'] The default format to use when the yup method is invoked with no arguments
 *
 * @example
 * import { addFormatTnToYup } from '@somosengineering/js-util-lib';
 * import { string, object } from 'yup'
 *
 * // Add the method to Yup
 * addFormatTnToYup();
 *
 * // Using the method in a schema
 * const schema = object({
 *    // Default format
 *    tfn: string().formatTn(),
 *    // Custom format
 *    tfn2: string().formatTn('(npa) nxx xxxx'),
 * })
 *
 */
const addFormatTnToYup = (defaultFormat = 'npa-nxx-xxxx') =>
   addMethod(string, 'formatTn', function formatTnYup(format = defaultFormat) {
      return this.transform(value => {
         // don't format tn if it's too long or too short
         if (value.length !== 10) {
            return value;
         }

         return formatTn(value, format);
      });
   });

export { addFormatTnToYup };
